module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "play",
    on: {
      "click": _vm.yo
    }
  }, [_c('svg', {
    attrs: {
      "id": "play",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1000",
      "height": "1000",
      "viewBox": "0 0 1000 1000"
    }
  }, [_c('title', [_vm._v("play")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_2",
      "data-name": "Layer 2"
    }
  }, [_c('rect', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "width": "1000",
      "height": "1000"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_1",
      "data-name": "Layer 1"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "id": "Y",
      "d": "M835.10411,570.82564,709.06139,771.27937,569.351,570.82564M709.06092,926.55522V771.27949"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "id": "A",
      "d": "M143.40182,924.2773,292.22357,573.10356h14.04694L456.61083,924.2773m-237.27955-175.397H380.6814"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "id": "L",
      "d": "M821.06073,436.12287H583.16792V84.94912"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "id": "P",
      "d": "M177.41085,439.072V86H327.5732a94.53216,94.53216,0,1,1,0,189.06431H181.20732"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73439d73","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Play.vue
// module id = 218
// module chunks = 1